import { render, staticRenderFns } from "./BufferInvoice.vue?vue&type=template&id=37fca57a"
import script from "./BufferInvoice.vue?vue&type=script&lang=js"
export * from "./BufferInvoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports